// Code generated by master-scheme ServiceTypesGenerator - DO NOT EDIT
// Generator: /Users/victorvins/Projects/master-scheme/dsl/src/ts-api/ServiceTypesGenerator.scala

import { postEndpoint } from '@innolab-trader/tradovate-transport'
import type { ValidationError } from '@innolab-trader/tradovate-types'
import type { AchAccountType } from '@innolab-trader/tradovate-types/src/enums/achAccountType'

export interface LinkPlaidItem {
  financialInstitutionName?: string
  accountType: AchAccountType
  accountNumber: string
  routingNumber?: string
  dormanAccountId: number
  dormanAccountName: string
  accountId: string
  publicToken: string
}

export interface AchApplicationResponse {
  errorText?: string
  achApplicationId?: number
}

/**
 * Validate LinkPlaidItem request
 *
 * Follows Rust validation pattern with structured errors
 *
 * @param request - The request object to validate
 * @returns Array of validation errors, empty if valid
 *
 * @example
 * ```typescript
 * const errors = validateLinkPlaidItem(requestData)
 * if (errors.length > 0) {
 *   return { status: 400, errors }
 * }
 * ```
 */
export function validateLinkPlaidItem(request: LinkPlaidItem): ValidationError[] {
  const errors: ValidationError[] = []

  const req = request as unknown as Record<string, unknown>
  if (typeof req.financialInstitutionName === 'string' && req.financialInstitutionName.length > 64) {
    errors.push({
      field: 'financialInstitutionName',
      code: 'too_long',
      message: 'financialInstitutionName must not exceed 64 characters',
      argument: '64'
    })
  }

  if (req.accountType === undefined || req.accountType === null) {
    errors.push({
      field: 'accountType',
      code: 'required',
      message: 'accountType is required'
    })
  }

  if (req.accountNumber === undefined || req.accountNumber === null) {
    errors.push({
      field: 'accountNumber',
      code: 'required',
      message: 'accountNumber is required'
    })
  }
  if (typeof req.accountNumber === 'string' && req.accountNumber.length > 64) {
    errors.push({
      field: 'accountNumber',
      code: 'too_long',
      message: 'accountNumber must not exceed 64 characters',
      argument: '64'
    })
  }
  if (typeof req.accountNumber === 'string' && req.accountNumber.trim() === '') {
    errors.push({
      field: 'accountNumber',
      code: 'required',
      message: 'accountNumber cannot be empty'
    })
  }

  if (typeof req.routingNumber === 'string' && req.routingNumber.length > 64) {
    errors.push({
      field: 'routingNumber',
      code: 'too_long',
      message: 'routingNumber must not exceed 64 characters',
      argument: '64'
    })
  }

  if (req.dormanAccountId === undefined || req.dormanAccountId === null) {
    errors.push({
      field: 'dormanAccountId',
      code: 'required',
      message: 'dormanAccountId is required'
    })
  }

  if (req.dormanAccountName === undefined || req.dormanAccountName === null) {
    errors.push({
      field: 'dormanAccountName',
      code: 'required',
      message: 'dormanAccountName is required'
    })
  }
  if (typeof req.dormanAccountName === 'string' && req.dormanAccountName.length > 64) {
    errors.push({
      field: 'dormanAccountName',
      code: 'too_long',
      message: 'dormanAccountName must not exceed 64 characters',
      argument: '64'
    })
  }
  if (typeof req.dormanAccountName === 'string' && req.dormanAccountName.trim() === '') {
    errors.push({
      field: 'dormanAccountName',
      code: 'required',
      message: 'dormanAccountName cannot be empty'
    })
  }

  if (req.accountId === undefined || req.accountId === null) {
    errors.push({
      field: 'accountId',
      code: 'required',
      message: 'accountId is required'
    })
  }
  if (typeof req.accountId === 'string' && req.accountId.length > 8192) {
    errors.push({
      field: 'accountId',
      code: 'too_long',
      message: 'accountId must not exceed 8192 characters',
      argument: '8192'
    })
  }
  if (typeof req.accountId === 'string' && req.accountId.trim() === '') {
    errors.push({
      field: 'accountId',
      code: 'required',
      message: 'accountId cannot be empty'
    })
  }

  if (req.publicToken === undefined || req.publicToken === null) {
    errors.push({
      field: 'publicToken',
      code: 'required',
      message: 'publicToken is required'
    })
  }
  if (typeof req.publicToken === 'string' && req.publicToken.length > 8192) {
    errors.push({
      field: 'publicToken',
      code: 'too_long',
      message: 'publicToken must not exceed 8192 characters',
      argument: '8192'
    })
  }
  if (typeof req.publicToken === 'string' && req.publicToken.trim() === '') {
    errors.push({
      field: 'publicToken',
      code: 'required',
      message: 'publicToken cannot be empty'
    })
  }

  return errors
}

export const linkPlaidItem = postEndpoint<LinkPlaidItem, AchApplicationResponse>('/achApplication/linkPlaidItem')
